import { Helpers } from '../../helpers';
import { IPrioritizationCriterion } from '../../interfaces/iprioritization-criterion';
import { PrioritizationCategory } from '../prioritization-category';
import { PrioritizationCriteriaSetting } from '../prioritization-criteria-setting';
import { Scenario } from '../scenario';

export class PrioritizationCriterionBase {
  PrioritizationCriterionId: number;
  PrioritizationCategoryId: number;
  ScenarioId: number;
  HeirarchyLevel: number;
  Weight: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  PrioritizationCriteriaSettings_PrioritizationCriterion?: Array<PrioritizationCriteriaSetting> | null;
  PrioritizationCategory?: PrioritizationCategory;
  Scenario?: Scenario;

  constructor(item?: IPrioritizationCriterion) {
    if (item) {

      this.PrioritizationCriterionId = item.PrioritizationCriterionId;
      this.PrioritizationCategoryId = item.PrioritizationCategoryId;
      this.ScenarioId = item.ScenarioId;
      this.HeirarchyLevel = item.HeirarchyLevel;
      this.Weight = item.Weight;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.PrioritizationCriteriaSettings_PrioritizationCriterion = Helpers.createClassArray(PrioritizationCriteriaSetting, item.PrioritizationCriteriaSettings_PrioritizationCriterion);
      this.PrioritizationCategory = new PrioritizationCategory(item.PrioritizationCategory);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}